/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

module.exports = [{
  action: 'updateCustomerRunnerContractPayoutsByRootId',
  message: messages.SUCCESS_UPDATE_CUSTOMER_RUNNER_CONTRACT_PAYOUTS_BY_ROOT_ID,
  method: 'PATCH',
  path: '/customer/:customerId/runner-contract-payouts/:rootId',
  payloadType: 'collection',
  permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_RUNNER_CONTRACT_PAYOUT,
  requestSchema: requestSchemas.customerRunnerContractPayouts.updateCustomerRunnerContractPayoutsByRootId,
}];
